import { render, staticRenderFns } from "./terms-of-service.vue?vue&type=template&id=6ccbcca6"
import script from "./terms-of-service.vue?vue&type=script&lang=js"
export * from "./terms-of-service.vue?vue&type=script&lang=js"
import style0 from "./terms-of-service.vue?vue&type=style&index=0&id=6ccbcca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports